var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stripe-field-wrapper" }, [
    _c(
      "div",
      { staticClass: "stripe-field-container", class: _vm.fieldClass },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c("input", {
          ref: "input",
          staticClass: "stripe-field",
          attrs: { name: _vm.name, type: _vm.type, required: _vm.required },
          domProps: { value: _vm.value },
          on: {
            input: _vm.handleInput,
            focus: function($event) {
              _vm.focus = true
            },
            blur: function($event) {
              _vm.validate()
              _vm.focus = false
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-172601bc", { render: render, staticRenderFns: staticRenderFns })
  }
}